import { ImportCSVErrorMessage } from '@components/process-import-csv/process-import-csv.type';
import { TFunction } from 'i18next';

export const createGeneralErrorsMessage = (errors: Set<ImportCSVErrorMessage>, t: TFunction) => {
  let message = '';
  let idx = 0;
  errors.forEach((error: ImportCSVErrorMessage) => {
    idx++;
    message = `${message} ${t(error.literal, {
      message: t(error.message as string),
      columnValue: error.columnLabel,
    })} ${idx === 0 ? '' : '<br/>'}`;
  });
  return message;
};
